let forms = {
	sample_form: {
		forms: [
			{
				type: 'text',
				form_type: 'number',
				class: 'col-12 col-md-6',
				model: 'discountCode',
				validation: 'required|min:0|max:10|decimal',
				label: 'Value of Car',
			},
			{
				type: 'datepicker',
				form_type: 'year',
				format: 'yyyy',
				placement: 'bottom-end',
				model: 'startDate',
				label: 'Year of Manufacture',
				class: 'col-12 col-md-6',
				validation: 'required',
			},
			{
				type: 'select',
				class: 'col-12',
				model: 'vehicle_use',
				clearable: true,
				options: [
					{ val: 'PSV', label: 'Public Service' },
					{ val: 'PRIVATE', label: 'Private' },
				],
				validation: 'required',
				label: 'Vehicle Use',
			},
		],
	},
};

export default {
	forms: utils.generateAllFormData(forms),
};
